// extracted by mini-css-extract-plugin
module.exports = {"uk-h5-recommend-product":"style_uk-h5-recommend-product__bJ4p_"};